import React, { Component } from "react";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";

export default class checkout extends Component {
  render() {
    return (
      <div>
        <div
          className="body"
          style={{ marginTop: "45.1875px", transition: "margin 300ms ease 0s" }}
        >
          <Header search={{ ...this.props.match.params }} />
        </div>
        {/* order success block */}
        <div
          className="card border-width-2 border-radius-3 border-color-grey"
          style={{
            width: "45%",
            height: 250,
            marginTop: "20px",
            marginLeft: "25%",
          }}
        >
          <div className=" card-body text-center ">
            <h1 className="   text-6 font-weight-bold ">
              Your order is confirmed
            </h1>
            <p className=" text-5 text-center ">
              We are processing the order.You will receive a confirmation email
              with your order shortly.You can check all updates in
              <a target="blank" href={`${process.env.REACT_APP_URL}/merchant/orders`}>{""}
                {""}Orders {""}
              </a>{" "}
              page.
            </p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}


  
